var _rect, _rect2, _rect3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgItaly(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 18,
    viewBox: "0 0 25 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 24,
    height: 18,
    fill: "#F5F8FB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 7.5,
    height: 18,
    fill: "#2B9F5A"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    width: 7.5,
    height: 18,
    fill: "#DC251C"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItaly);
export default __webpack_public_path__ + "static/media/italy.5f0f868a.svg";
export { ForwardRef as ReactComponent };